//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import loading from 'components/refreshData/loading.vue';
export default {
  props: {
    parentPullUpState: {
      default: 0
    },
    onInfiniteLoad: {
      type: Function,
      require: false
    }
  },
  data: function data() {
    return {
      top: 0,
      startY: 0,
      pullUpState: 0,
      // 1:上拉加载更多, 2:加载中……, 3:我是有底线的
      isLoading: false,
      // 是否正在加载
      pullUpStateText: {
        moreDataTxt: '上拉加载更多',
        loadingMoreDataTxt: '加载中...',
        noMoreDataTxt: '我是有底线的'
      }
    };
  },
  components: {
    loading: loading
  },
  methods: {
    touchStart: function touchStart(e) {
      this.startY = e.targetTouches[0].pageY;
    },
    touchMove: function touchMove(e) {
      if (e.targetTouches[0].pageY < this.startY) {
        // 上拉
        this.judgeScrollBarToTheEnd();
      }
    },
    // 判断滚动条是否到底
    judgeScrollBarToTheEnd: function judgeScrollBarToTheEnd() {
      var innerHeight = document.querySelector('.loadMoudle').clientHeight; // 变量scrollTop是滚动条滚动时，距离顶部的距离

      var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop; // 变量scrollHeight是滚动条的总高度

      var scrollHeight = document.documentElement.clientHeight || document.body.scrollHeight; // 滚动条到底部的条件

      if (scrollTop + scrollHeight >= innerHeight) {
        if (this.pullUpState !== 3 && !this.isLoading) {
          this.pullUpState = 1;
          this.infiniteLoad(); // setTimeout(() => {
          //   this.infiniteLoad()
          // }, 200)
        }
      }
    },
    infiniteLoad: function infiniteLoad() {
      var _this = this;

      this.pullUpState = 2;
      this.isLoading = true;
      setTimeout(function () {
        _this.onInfiniteLoad(_this.infiniteLoadDone);
      }, 800);
    },
    infiniteLoadDone: function infiniteLoadDone() {
      this.pullUpState = 0;
      this.isLoading = false;
    }
  },
  watch: {
    parentPullUpState: function parentPullUpState(curVal, oldVal) {
      this.pullUpState = curVal;
    }
  }
};